import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { SuspensionDetailsImpl } from "../model/impl/SuspensionDetailsImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class SuspensionDetailsImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: SuspensionDetailsImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        SuspensionDetailsImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if (encodable.suspensionFromDts != null) {
      this.baseEncoder.writeStartFid(931, streamout);
      this.baseEncoder.writeObject(
        false,
        SuspensionDetailsImplEncoder.fidTypeMap.get(931),
        false,
        encodable.suspensionFromDts,
        streamout,
      );
      this.baseEncoder.writeEndFid(931, streamout);
    }
    /*Object encoding*/
    if (encodable.suspensionToDts != null) {
      this.baseEncoder.writeStartFid(932, streamout);
      this.baseEncoder.writeObject(
        false,
        SuspensionDetailsImplEncoder.fidTypeMap.get(932),
        false,
        encodable.suspensionToDts,
        streamout,
      );
      this.baseEncoder.writeEndFid(932, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,SuspensionDetailsImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [100, "java.lang.String"],
    [931, "java.util.Date"],
    [932, "java.util.Date"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: SuspensionDetailsImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            SuspensionDetailsImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 931: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            SuspensionDetailsImplEncoder.fidTypeMap.get(931),
            streamin,
          );
          encodable.suspensionFromDts = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 932: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            SuspensionDetailsImplEncoder.fidTypeMap.get(932),
            streamin,
          );
          encodable.suspensionToDts = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,SuspensionDetailsImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return SuspensionDetailsImplEncoder.fidTypeMap.has(fid);
  }
}
